import { api } from '@/services/http.service';
import { defineStore } from 'pinia';
import { CountryItem } from '@/models/dictionary/country-list.model';
import { ElNotification } from 'element-plus';

interface CountryListStore {
  countryList: CountryItem[];
  isCountryListLoading: boolean;
}

export const useCountryListStore = defineStore({
  id: 'CountryListStore',
  state: (): CountryListStore => ({
    countryList: [],
    isCountryListLoading: false,
  }),
  actions: {
    setCountryListLoading(isLoading: boolean): void {
      this.isCountryListLoading = isLoading;
    },
    getCountryName(code: string): string {
      if (!code) {
        return '';
      }

      const country = this.countryList.find(country => country.code === code);

      return country?.name || code;
    },
    getCountryList(): Promise<CountryItem[]> {
      if (this.countryList.length) {
        return Promise.resolve(this.countryList);
      }

      this.setCountryListLoading(true);

      return api.dictionary.getCountryListRequest.perform()
        .then(response => {
          this.countryList = response;

          return response;
        }).catch(error => {
          ElNotification({
            title: 'Error',
            message: error.message,
            type: 'error',
          });

          return [];
        }).finally(() => this.setCountryListLoading(false));
    },
  },
});
